import React, {useState} from 'react';
import {Button, Modal, ModalBody, Input} from 'reactstrap';

const DeleteButton = ({onClick, entityLabel, title, typeToConfirm, color = 'danger', outline = true}) => {
    const [modal, setModal] = useState(false);
    const [confirmInput, setConfirmInput] = useState('');
    const isConfirmed = !typeToConfirm || title.toLowerCase() === confirmInput.toLowerCase();

    const handleDelete = async (e) => {
        onClick(e);
        setModal(false);
        setConfirmInput('');
    };

    const toggle = () => {
        setModal(!modal);
        setConfirmInput('');
    };

    return (
        <>
            <Button
                color={color}
                outline={outline}
                onClick={toggle}
                title={`Delete ${title}`}
                className={color === 'link' ? 'text-decoration-none text-danger' : ''}
            >
                <span className="fas fa-trash me-2"/>
                Delete {entityLabel}
            </Button>

            <Modal isOpen={modal} toggle={toggle} centered>
                <ModalBody className="text-center p-4">
                    <div className="text-danger mb-3">
                        <span className="fas fa-exclamation-triangle fa-3x"/>
                    </div>

                    <h4 className="mb-2">Delete {entityLabel}?</h4>

                    <div className="bg-danger bg-opacity-10 border border-danger border-opacity-25 rounded p-3 my-3">
                        <h5 className="mb-0 text-danger fw-bold">{title}</h5>
                    </div>

                    <p className="text-secondary small mb-4">
                        This action cannot be undone.
                    </p>

                    {typeToConfirm && (
                        <div className="text-start mb-4">
                            <label className="form-label small text-secondary">
                                Type <code className="text-danger">{title}</code> to confirm
                            </label>
                            <Input
                                type="text"
                                value={confirmInput}
                                onChange={e => setConfirmInput(e.target.value)}
                                placeholder={title}
                                className={isConfirmed && confirmInput ? 'border-success' : ''}
                            />
                        </div>
                    )}

                    <div className="d-flex gap-2">
                        <Button color="secondary" outline onClick={toggle} className="flex-grow-1">
                            Cancel
                        </Button>
                        <Button
                            color="danger"
                            onClick={handleDelete}
                            disabled={!isConfirmed}
                            className="flex-grow-1"
                        >
                            <span className="fas fa-trash me-2"/>
                            Delete
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default DeleteButton;
